import Store from "@/store/index.js";
import axios from 'axios'
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
const domain = Store.state.domain;

export default {

    ObtenerCorreosAdjuntos(vm, datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("aiclave", datos.aiclave);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ObtenerCorreosAdjuntos`, formData).then(response => response.data)
    },
    ObtenerLlamadasAdjuntas(vm, datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("aiclave", datos.aiclave);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ObtenerLlamadasAdjuntas`, formData).then(response => response.data)
    },
    async ObtenerDireccion(datos, docid, pagina) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("docid", docid);
        formData.append("pagina", pagina);
        return axios.post(`${domain.domainNameForApi}Documentos/ObtenerDireccion`, formData).then(response => response.data);
    },
    DescargarZip(vm, datos, docid, pagina, dodescrip) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("docid", docid);
        formData.append("pagina", pagina);
        formData.append("dodescrip", dodescrip);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/DescargarZip`, formData, { responseType: 'blob', }).then(response => response.data);
    },
    AlmacenarVisitas(datos) {
        return axios.post(`${domain.domainNameForApi}Documentos/AlmacenarVisitas`, datos).then(response => response.data);
    },
    ValidarAsistenciaArchivos(vm, datos) {
        //console.log(datos);
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ValidarAsistenciaArchivos`, formData).then(response => response.data);
    },
    ObtenerDocumentosAdjuntos(vm, datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ObtenerDocumentosAdjuntos`, formData).then(response => response.data);
    },
    ObtenerDocumentosFaltantes(vm, datos) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ObtenerDocumentosFaltantes`, datos).then(response => response.data);
    },
    SubirArchivo(vm, datos) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/SubirArchivo`, datos, { headers: { 'content-type': 'multipart/form-data' } }).then(response => response.data);
    },
    ValidaSubirArchivo(vm, datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ValidaSubirArchivo`, formData).then(response => response.data);
    },
    DocumentacionDudosa(vm, datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/DocumentacionDudosa`, formData).then(response => response.data);
    },
    ValidaDocumentacionCliente(vm, datos) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ValidaDocumentacionCliente`, datos).then(response => response.data);
    },
    DocumentacionFisica(vm, datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/DocumentacionFisica`, formData).then(response => response.data);
    },
    UnirArchivo(vm, datos) {
        var formData = new FormData();
        formData.append("data", datos);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/UnirArchivo`, formData).then(response => response.data);
    },
    async ObtenerVideosAdjuntos(vm) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("aiclave", datos.aiclave);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ObtenerVideosAdjuntos`, datosReporte).then(response => response.data)
    },
    ObtenerVideoFile(vm, datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("docid", docid);
        formData.append("pagina", pagina);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ObtenerVideoFile`, formData).then(response => response.data);
    },
    DescargarVideo(vm, rutaarchivo) {
        var formData = new FormData();
        formData.append("rutaarchivo", rutaarchivo);
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/DescargarVideo`, formData).then(response => response.data);
    },
    async DescargaZip(datos, docid, dodescrip) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("docid", docid);
        datosReporte.append("dodescrip", dodescrip);
        let response = await axios.post(`${domain.domainNameForApi}Documentos/DescargaArchivoZIP`, datosReporte, { responseType: 'blob', });
        return response.data;
    },
}